/* eslint-disable no-undef */
import { API_BASE_URL } from '../../../config/constants'
import { ApiClient } from '../../../services'

const client = new ApiClient()

type LoginInput = { email: string; password: string }

const login = async (input: LoginInput) => {
  const response = await client.post(`/auth/login`, input)
  const payload = response?.data

  if (payload) {
    // Check if 2FA is required
    if (payload?.requiresTwoFactor) {
      // Don't store tokens or user yet - wait for 2FA verification
      // Just return the response to trigger the 2FA modal
      return response
    }

    if (payload?.needVerify) {
      localStorage.setItem('twoFAToken', payload.tokens?.access_token)
    } else {
      localStorage.setItem('jwt', payload.tokens?.access_token)
    }
    localStorage.setItem('user', JSON.stringify(payload.user))

    // set driver
    const { tutorials } = payload.user

    if (tutorials) {
      Object.keys(tutorials).forEach((key: string) => {
        localStorage.setItem(key, tutorials?.[key])
      })
    }
  }

  if (response?.errors) {
    localStorage.removeItem('jwt')
    localStorage.removeItem('user')
  }

  return response
}

const getPublicSupport = () => {
  return client.get(`/supports/public`)
}

const getSupports = ({ companyId }: { companyId: number }) => {
  return client.get(`/supports/${companyId}`)
}

const getApiVersion = async () => {
  const url = API_BASE_URL?.replace('api/v2', 'version') as string
  const response = await fetch(url, { method: 'GET' })

  const version = await response.text()

  return version
}

const authService = { login, getSupports, getApiVersion, getPublicSupport }

export default authService
